/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import Peripherals from '@appblocks/codegeneration/Peripherals';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];
    const NAME = feature.getSettingValue('NAME');
    const PIN = feature.getSettingValue('PIN');
    const DIRECTION = feature.getSettingValue('DIRECTION');
    const STATE = feature.getSettingValue('STATE');

    const peripherals = Peripherals.getPin(PIN, feature.project.device.id)?.peripherals;
    let gpioNum = PIN;
    // if (peripherals) {
    //     gpioNum = peripherals.filter(p => p.peripheralType === 'gpio')[0].peripheralPort;
    // }

    if (DIRECTION === '1') {
        // interrupt

        blocks.push({
            location: 'VARIABLE_DECLARATIONS',
            blockType: BlockType.CODE,
            template: `${NAME}_pin = machine.Pin(${gpioNum}, machine.Pin.IN, machine.Pin.${STATE === '1' ? 'PULL_UP' : 'PULL_DOWN'})`,
        });

        //         blocks.push({
        //             location: 'boot',
        //             blockType: BlockType.CODE,
        //             template: `
        // ${NAME}_pin.irq(trigger=machine.Pin.IRQ_RISING, handler=${NAME}_pin_handler)`,
        //         });

        //         blocks.push({
        //             location: 'FUNCTION_DECLARATIONS',
        //             blockType: BlockType.CODE,
        //             template: `
        // def ${NAME}_pin_handler(p):
        //     var_${NAME}_set(${NAME}_pin.value())`,
        //         });


        blocks.push({
            location: `var_${NAME}_update`,
            blockType: BlockType.CODE,
            template: `var_${NAME}_set(${NAME}_pin.value())`,
        });
    } else {
        blocks.push({
            location: 'VARIABLE_DECLARATIONS',
            blockType: BlockType.CODE,
            template: `${NAME}_pin = machine.Pin(${gpioNum}, machine.Pin.OUT)`,
        });

        blocks.push({
            location: `var_${NAME}_set`,
            blockType: BlockType.CODE,
            template: `pin = machine.Pin(${gpioNum}, machine.Pin.OUT)
pin.value(value)`,
        });
    }

    return blocks;
};
